export default {
  steps: {
    0: {
      title: 'Bliv stamkunde',
      description: 'Se din bestillingshistorik, og bestil igen med et enkelt tryk.',
    },
    1: {
      title: 'Få belønninger',
      description: 'Hold styr på dine point, og indløs gemte belønninger fra din tegnebog.',
    },
    2: {
      title: 'Bestil i forvejen',
      description: 'Find din nærmeste lokation, og afgiv en bestilling hurtigere end nogensinde.',
    },
  },
  buttons: {
    skip: 'Spring over',
  },
};
